import { enTabPacketType } from "./CodeEnum";
import { decodeForWeb, encodeForWeb } from "./Token";
import { getIsPblCurrentPage } from "../RabbitmqClient";

const encodePacket = (data, dataType, name) => {
    let rtnValue = {};
    let idx = 0;

    let encoder = new TextEncoder();
    let nameData = encoder.encode(name);

    let int64Buff = new ArrayBuffer(8);
    let int64Int8View = new Uint8Array(int64Buff);
    let int64Int32View = new Int32Array(int64Buff);
    let pktLength = 4 + 1 + 1 + nameData.length + 4 + data.length;

    int64Int32View[0] = pktLength;
    int64Int32View[1] = data.length;

    let arrayBuffer = new ArrayBuffer(pktLength);
    let int8View = new Uint8Array(arrayBuffer);

    for (let i = 0; i < 4; i++) {
        int8View[idx++] = int64Int8View[i];
    }

    int8View[idx++] = dataType;
    int8View[idx++] = nameData.length;

    for (let i = 0; i < nameData.length; i++) {
        int8View[idx++] = nameData[i];
    }

    for (let i = 0; i < 4; i++) {
        int8View[idx++] = int64Int8View[4 + i];
    }

    for (let i = 0; i < data.length; i++) {
        int8View[idx++] = data[i];
    }

    rtnValue.forHiclass = Array.from(int8View);
    // rtnValue.forWeb = int8View;
    rtnValue.forWeb = arrayBuffer;

    return rtnValue;
};

const encodeBinary = (data, name) => {
    return encodePacket(data, enTabPacketType.Binary, name);
};

export const encodeText = (data, name) => {
    return this.encodePacket(data, enTabPacketType.Text, name);
};

export const decodingPacket = (rawBuffer) => {
    let idx = 0;

    // let int8View = new Uint8Array(rawBuffer);
    // Buffer / Uint8Array / ArrayBuffer 모두 대응
    const int8View =
        rawBuffer instanceof Uint8Array
            ? rawBuffer
            : new Uint8Array(rawBuffer);

    let int32Buff = new ArrayBuffer(4);
    let int32Int8View = new Uint8Array(int32Buff);
    let int32View = new Int32Array(int32Buff);

    int32Int8View[0] = int8View[idx++];                         // [0]
    int32Int8View[1] = int8View[idx++];                         // [1]
    int32Int8View[2] = int8View[idx++];                         // [2]
    int32Int8View[3] = int8View[idx++];                         // [3]
    let pktLength = int32View[0];
    let pktType = int8View[idx++];                              // [4]

    let nameLength = int8View[idx++];                           // [5]
    let nameBuffer = rawBuffer.slice(idx, idx + nameLength);    // [6]
    let decoder = new TextDecoder("utf-8");
    let packName = decoder.decode(nameBuffer);
    idx = idx + nameLength;

    int32Int8View[0] = int8View[idx++];                         // [6 + nameLength]
    int32Int8View[1] = int8View[idx++];                         // [7 + nameLength]
    int32Int8View[2] = int8View[idx++];                         // [8 + nameLength]
    int32Int8View[3] = int8View[idx++];                         // [9 + nameLength]
    let dataLength = int32View[0];

    let dataBuffer = rawBuffer.slice(idx);                      // [10 + nameLength]
    let dataObject = decodeForWeb(dataBuffer);

    if (getIsPblCurrentPage()) {
        return Object.assign({ name: packName, dataBuffer: dataBuffer, dataLength: dataLength }, dataObject);
    } else {
        return Object.assign({ name: packName }, dataObject);
    }
};

export const getSendToMQBytes = (sendObject, senderName) => {
    const sendData = encodeForWeb(sendObject);
    const sendDataBin = encodeBinary(sendData, senderName);

    return sendDataBin;
};

/**
 * 바이트 데이터를 base64 문자열로 변환하는 메서드
 * String.fromCharCode.apply(null, 큰배열) 사용 시 인자 수 제한(약 10만개)으로
 * RangeError(Maximum call stack size exceeded)가 발생하므로 32KB 단위로 나누어 변환한다.
 * 20261015 음성메모(8초 이상) 등 대용량 데이터 전송 실패 수정
 * 
 * @param {Array|Uint8Array|ArrayBuffer} data - 변환할 바이트 데이터
 * @returns {String} base64 문자열
 * @since 2026-10-15.
 */
export const bytesToBase64 = (data) => {
    const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
    const CHUNK_SIZE = 0x8000;
    let binary = "";

    for (let i = 0; i < bytes.length; i += CHUNK_SIZE) {
        binary += String.fromCharCode.apply(null, bytes.subarray(i, i + CHUNK_SIZE));
    }

    return btoa(binary);
};

/**
 * Pentalk Pro에서 받은 RBMQ 메시지 데이터를
 * Pentalk WiFi에 전달해야 하는 경우
 * Token 데이터 형식까지로만 encode해서 반환하는 메서드
 * 
 * @param {Object} sendObject - 전달할 데이터
 * @returns {ArrayBuffer}
 * @since 2025-07-16.
 */
export const getSendToWiFiBytes = (sendObject) => {
    const sendData = encodeForWeb(sendObject);

    return sendData;
};

/**
 * Pentalk WiFi에서 받은 Token 데이터를
 * Pentalk Pro에 전달해야 하는 경우
 * Token 데이터를 Packet 데이터 형식으로 encode해서
 * 반환하는 메서드
 * 
 * @param {ArrayBuffer} tokenBuffer - 전달할 Token 데이터
 * @param {String} senderName - 전달할 사용자 닉네임
 * @since 2025-07-23.
 */
export const getSendToEncodeBytes = (tokenBuffer, senderName) => {
    const sendDataBin = encodeBinary(tokenBuffer, senderName);

    return sendDataBin;
};